var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { getCosmosDataProps } from "../utils/comsosCompat";
// this needs to be a function instead of a component since MUI derives the value by mapping over the first layer of children.
export var renderSelectOptions = function (_a) {
    var options = _a.options, value = _a.value;
    return options.map(function (option) { return (React.createElement("option", __assign({ key: option.value, role: "option", value: option.value, "aria-selected": option.value === value, disabled: option.disabled }, getCosmosDataProps("select.option")), option.text)); });
};
